import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AuthService {
  constructor() {}
  showAuthModal = new Subject();
}
